"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "authTypes", {
  enumerable: true,
  get: function get() {
    return _authType.authTypes;
  }
});
Object.defineProperty(exports, "clearLocalToken", {
  enumerable: true,
  get: function get() {
    return _core.clearLocalToken;
  }
});
Object.defineProperty(exports, "clearTokens", {
  enumerable: true,
  get: function get() {
    return _tokens.clearTokens;
  }
});
Object.defineProperty(exports, "fetchAccessToken", {
  enumerable: true,
  get: function get() {
    return _tokens.fetchAccessToken;
  }
});
Object.defineProperty(exports, "fetchRefreshTokenEmailPass", {
  enumerable: true,
  get: function get() {
    return _tokens.fetchRefreshTokenEmailPass;
  }
});
Object.defineProperty(exports, "fetchRefreshedRefreshToken", {
  enumerable: true,
  get: function get() {
    return _tokens.fetchRefreshedRefreshToken;
  }
});
Object.defineProperty(exports, "fetchToken", {
  enumerable: true,
  get: function get() {
    return _core.fetchToken;
  }
});
Object.defineProperty(exports, "getAccessToken", {
  enumerable: true,
  get: function get() {
    return _tokens.getAccessToken;
  }
});
Object.defineProperty(exports, "getAccessTokenWithRefreshToken", {
  enumerable: true,
  get: function get() {
    return _fetchers.getAccessTokenWithRefreshToken;
  }
});
Object.defineProperty(exports, "getAuthType", {
  enumerable: true,
  get: function get() {
    return _authType.getAuthType;
  }
});
Object.defineProperty(exports, "getLocalToken", {
  enumerable: true,
  get: function get() {
    return _core.getLocalToken;
  }
});
Object.defineProperty(exports, "getRefreshToken", {
  enumerable: true,
  get: function get() {
    return _tokens.getRefreshToken;
  }
});
Object.defineProperty(exports, "getRefreshTokenWithEmailPass", {
  enumerable: true,
  get: function get() {
    return _fetchers.getRefreshTokenWithEmailPass;
  }
});
Object.defineProperty(exports, "getTimeUntilExpiration", {
  enumerable: true,
  get: function get() {
    return _core.getTimeUntilExpiration;
  }
});
Object.defineProperty(exports, "persistAccessToken", {
  enumerable: true,
  get: function get() {
    return _tokens.persistAccessToken;
  }
});
Object.defineProperty(exports, "persistRefreshToken", {
  enumerable: true,
  get: function get() {
    return _tokens.persistRefreshToken;
  }
});
Object.defineProperty(exports, "redirectToLogin", {
  enumerable: true,
  get: function get() {
    return _redirectToLogin["default"];
  }
});
Object.defineProperty(exports, "redirectToLoginIfNoAccessToken", {
  enumerable: true,
  get: function get() {
    return _redirectToLoginIfNoAccessToken["default"];
  }
});
Object.defineProperty(exports, "redirectToLoginIfNoRefreshToken", {
  enumerable: true,
  get: function get() {
    return _redirectToLoginIfNoRefreshToken["default"];
  }
});
Object.defineProperty(exports, "redirectToLogout", {
  enumerable: true,
  get: function get() {
    return _redirectToLogout["default"];
  }
});
Object.defineProperty(exports, "redirectToUrlWithRefreshToken", {
  enumerable: true,
  get: function get() {
    return _redirectToUrlWithRefreshToken["default"];
  }
});
Object.defineProperty(exports, "refetchWhenExpires", {
  enumerable: true,
  get: function get() {
    return _core.refetchWhenExpires;
  }
});
Object.defineProperty(exports, "refreshRefreshToken", {
  enumerable: true,
  get: function get() {
    return _fetchers.refreshRefreshToken;
  }
});
var _core = require("./core");
var _fetchers = require("./fetchers");
var _redirectToLogin = _interopRequireDefault(require("./redirectToLogin"));
var _redirectToLoginIfNoAccessToken = _interopRequireDefault(require("./redirectToLoginIfNoAccessToken"));
var _redirectToLoginIfNoRefreshToken = _interopRequireDefault(require("./redirectToLoginIfNoRefreshToken"));
var _redirectToLogout = _interopRequireDefault(require("./redirectToLogout"));
var _redirectToUrlWithRefreshToken = _interopRequireDefault(require("./redirectToUrlWithRefreshToken"));
var _tokens = require("./tokens");
var _authType = require("./authType");